import PropTypes from 'prop-types'

import {List, Map} from 'immutable'
import {connect} from 'react-redux'

import defaultAdvisorAvatar from '../../../../../shared_assets/default-advisor-avatar.svg'
import {addPossessive} from '../../../../../lib/tools'
import {BoxGutterMedium} from '../../blocks/Boxes'
import {Icon} from '../../../../../shared_components/Icon'
import {TextGutterMedium} from '../../../../../dashboard/src/components/blocks/Texts'

import './providedByInformation.scss'

export const ProvidedByInformation = ({advisorContactCard, items}) => (
  <BoxGutterMedium className='provided-by-information'>
    <h2>Your Everplan is provided by</h2>
    <div className='provided-by-information-contact-card flex-container'>
      <img
        alt={`${addPossessive(advisorContactCard.get('name'))} head shot`}
        className='advisor-head-shot flex-child'
        src={
          advisorContactCard.get('avatar-url') ?
            advisorContactCard.get('avatar-url') :
            defaultAdvisorAvatar
        }
      />
      <div className='contact-information flex-child flex-container'>
        <div className='contact-information-row flex-child name'>
          <strong>{advisorContactCard.get('name')}</strong>
        </div>
        {
          advisorContactCard.get('firm-name') &&
          advisorContactCard.get('firm-type') !== 'funeral_home' &&
          <div className='contact-information-row flex-child'>
            {advisorContactCard.get('firm-name')}
          </div>
        }
        <div className='contact-information-row flex-child'>
          <Icon className='fa-envelope-o' />
          <a href={`mailto:${advisorContactCard.get('email')} `}>
            Send an email
          </a>
        </div>
        {
          advisorContactCard.get('phone') &&
          (
            <div className='contact-information-row flex-child'>
              <Icon className='fa-phone' />
              {advisorContactCard.get('phone')}
            </div>
          )
        }
        {
          advisorContactCard.get('url') &&
          (
            <div className='contact-information-row flex-child'>
              <Icon className='fa-globe' />
              <a
                href={advisorContactCard.get('url')}
                rel='noreferrer'
                target='_blank'>
                Website
              </a>
            </div>
          )
        }
      </div>
    </div>
    {
      advisorContactCard.get('firm-type') === 'funeral_home' &&
      <>
        <p>
          As your funeral home, {''}
          <strong>{advisorContactCard.get('name')}</strong> {''}
          has permission to edit the following sections of your Everplan:
        </p>
        <ul>
          {
            items.map(item => (
              <li key={item.get('id')}>{item.get('name')}</li>
            ))
          }
        </ul>
        <p>
          Authorized representatives of the {''}
          <strong>{advisorContactCard.get('name')}</strong> {''}
          will be able to view, edit, add, remove, and download the content of
          these sections.
        </p>
      </>
    }
    {
      advisorContactCard.get('firm-type') !== 'funeral_home' &&
      <TextGutterMedium>
        If you would like to disassociate your account, please contact{' '}
        {advisorContactCard.get('name')}.
      </TextGutterMedium>
    }
  </BoxGutterMedium>
)

ProvidedByInformation.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map),
  items: PropTypes.instanceOf(List)
}

const mapStateToProps = (state, {firmOwnership}) => ({
  categories: state.categories,
  items: state.items.filter(
    item => firmOwnership.get('edit-item-ids').includes(item.get('id'))
  )
})

export default connect(mapStateToProps)(ProvidedByInformation)
